export const TRONGRID_API_URL = 'https://api.trongrid.io';
